'use strict';

const _=require('pulsar-utils/dist-es6/_');let

WaypointType=class WaypointType{
constructor(category,stopType,stopTitle,durationInHours){
this._category=category;
this._stopType=stopType;
this._stopTitle=stopTitle;
this._durationInHours=durationInHours;
}

get category(){
return this._category;
}

get stopType(){
return this._stopType;
}

get label(){
let durationString=this.durationInHours<1?
`(${this.durationInHours*60} min)`:
`(${this.durationInHours} h)`;

return this._category!==null?
`${_.upperFirst(this._category)} - ${this._stopTitle} ${durationString}`:
this._stopTitle;
}

get stopTitle(){
return this._stopTitle;
}

get durationInHours(){
return this._durationInHours;
}};



const allWaypointTypes={
unselected:new WaypointType(null,'none','Not Selected',0),
load:new WaypointType('load','load','Live Load',2),
loadDropHook:new WaypointType('load','drophook','Drop and Hook',.75),
unload:new WaypointType('unload','unload','Live Load',2),
unloadDropHook:new WaypointType('unload','drophook','Drop and Hook',.75)};let




WaypointTypes=class WaypointTypes{
static get all(){
return _.values(allWaypointTypes);
}

static get unselected(){return allWaypointTypes.unselected}
static get load(){return allWaypointTypes.load}
static get loadDropHook(){return allWaypointTypes.loadDropHook}
static get unload(){return allWaypointTypes.unload}
static get unloadDropHook(){return allWaypointTypes.unloadDropHook}};




module.exports=WaypointTypes;
//# sourceMappingURL=waypointTypes.js.map
